export default "__VITE_PUBLIC_ASSET__e09a4bbe__"